import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import PageHero from '../ui/pageHero/PageHero';
import { fadeUp, stagger, viewportOnce } from '../../styles/animations';

const channels = [
    { label: 'Email', value: 'hello@nexora.studio', href: 'mailto:hello@nexora.studio' },
    { label: 'Location', value: 'Berlin · Remote-first', href: undefined },
];

const ContactPage = () => (
    <>
        <PageHero
            eyebrow="Contact"
            title="Let's talk"
            subtitle="Tell us about the challenge. We'll tell you honestly whether we're the right team for it."
        />

        <Box component="section" sx={{ backgroundColor: 'background.default', py: { xs: 8, md: 12 }, px: '6%' }}>
            <Box sx={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: { xs: 6, md: 10 } }}>
                <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={fadeUp}>
                    <Typography variant="h2" sx={{ mb: 3 }}>Start a project</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 440 }}>
                        The fastest way to reach us is a short email — what you're trying
                        to solve, and roughly where you are today. No forms to fill out.
                    </Typography>
                    <Button variant="contained" href="mailto:hello@nexora.studio">
                        Email hello@nexora.studio
                    </Button>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    variants={stagger(0.1)}
                    style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}
                >
                    {channels.map((c) => (
                        <motion.div key={c.label} variants={fadeUp}>
                            <Typography variant="overline" sx={{ color: 'primary.main', display: 'block', mb: 0.5 }}>
                                {c.label}
                            </Typography>
                            {c.href ? (
                                <Typography
                                    component="a"
                                    href={c.href}
                                    variant="h4"
                                    sx={{ color: 'text.primary', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
                                >
                                    {c.value}
                                </Typography>
                            ) : (
                                <Typography variant="h4">{c.value}</Typography>
                            )}
                        </motion.div>
                    ))}
                </motion.div>
            </Box>
        </Box>
    </>
);

export default ContactPage;
